
<template>
    <div class="auth-page-wrapper pt-5">
        <!-- auth page bg -->
        <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
            <div class="bg-overlay"></div>
            <div class="shape">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
                    <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
                </svg>
            </div>
        </div>

        <!-- auth page content -->
        <div class="auth-page-content">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center mt-sm-5 mb-4 text-white-50">
                            <div>
                                <router-link to="/" class="d-inline-block auth-logo">
                                    <img
                                        src="@/assets/images/logo-light.png"
                                        alt=""
                                        height="20"
                                    />
                                </router-link>
                            </div>
                            <p class="mt-3 fs-15 fw-medium">
                                بزرگترین بازار آنلاین خرید و فروش زیورآلات در ایران
                            </p>
                        </div>
                    </div>
                </div>
                <!-- end row -->

                <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-6 col-xl-5">
                        <div class="card mt-4">
                            <div class="card-body p-4">
                                <div class="text-center mt-2">
                                    <h5 class="text-primary">به مرکز شعب طلاباش
                                        خوش آمدید!</h5>
                                    <p class="text-muted">برای ادامه، وارد پنل شوید.</p>
                                </div>
                                <div class="p-2 mt-4">
                                    <b-alert
                                        v-model="isAuthError"
                                        variant="danger"
                                        class="mt-3"
                                        dismissible
                                    >{{ authError }}</b-alert
                                    >

                                    <div
                                        v-if="notification.message"
                                        :class="'alert ' + notification.type"
                                    >
                                        {{ notification.message }}
                                    </div>

                                    <form @submit.prevent="tryToLogIn">
                                        <div class="mb-3">
                                            <label for="username" class="form-label">نام کاربری</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="username"
                                                placeholder="نام کاربری"
                                                v-model="username"
                                            />
                                        </div>
                                        <div class="mb-3">
                                            <label for="password" class="form-label">کلمه عبور</label>
                                            <input
                                                type="password"
                                                class="form-control"
                                                id="password"
                                                placeholder="کلمه عبور"
                                                v-model="password"
                                            />
                                        </div>

                                        <div class="mt-4">
                                            <button class="btn btn-success w-100" type="submit">
                                                ورود به پنل
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <!-- end card body -->
                        </div>
                        <!-- end card -->

                    </div>
                </div>
                <!-- end row -->
            </div>
            <!-- end container -->
        </div>
        <!-- end auth page content -->

        <!-- footer -->
        <footer class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center">
                            <p class="mb-0 text-muted">
                                ساخته شده با
                                <i class="mdi mdi-heart text-danger"></i>
                                توسط طلاباش
                                &copy; {{ new Date().getFullYear() }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!-- end Footer -->
    </div>
    <!-- end auth-page-wrapper -->
</template>

<script>
import useVuelidate from "@vuelidate/core";
import appConfig from "../../../app.config";

import {
    notificationMethods,
} from "@/state/helpers";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    page: {
        title: "Login",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            username: "",
            password: "",
            submitted: false,
            authError: null,
            tryingToLogIn: false,
            isAuthError: false,
        };
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
        notification() {
            return this.$store ? this.$store.state.notification : null;
        },
    },
    created() {
        if (this.loggedIn) {
            this.$router.push("/");
        }
    },
    methods: {
        ...notificationMethods,
        // Try to log the user in with the username
        // and password they provided.
        tryToLogIn() {
            this.submitted = true;
            // stop here if form is invalid
            this.v$.$touch();

            if (this.v$.$invalid) {
                return;
            } else {
                this.tryingToLogIn = true;
                // Reset the authError if it existed.
                this.authError = null;
                this.isAuthError = false;
                this.clear();
                return (
                    this.$store.dispatch('auth/login', {
                        username: this.username,
                        password: this.password,
                    })
                        // eslint-disable-next-line no-unused-vars
                        .then((response) => {
                            const {data, status} = response
                            const {code, message} = data;
                            if(status === 201) {
                                this.tryingToLogIn = false;
                                this.authError = message ? message : "";
                                this.isAuthError = true;
                            }
                            if(status === 202 && code === 'otp') {
                                this.otpSent = true;
                                this.success(message)
                            }
                            if(data.token) {
                                // Redirect to the originally requested page, or to the home page
                                this.$router.push(
                                    this.$route.query.redirectFrom || {
                                        name: "default",
                                    }
                                );
                            }
                        })
                        .catch((error) => {
                            this.tryingToLogIn = false;
                            this.authError = error ? error : "";
                            this.isAuthError = true;
                        })
                );
            }
        },
    },
};
</script>

<style scoped>
input#mobile {
    direction: ltr;
}
</style>

